function initScrollTransform() {
    var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if ($('html').hasClass('no-touchevents') && !is_safari) {
        $(window).scroll(function (e) {
            scrollStep = $(window).scrollTop();

            // Header photo
            var zoomXY = (scrollStep / 4000) + 1;
            if (zoomXY < 1.4) $(".header-bg").css("transform", "matrix(" + zoomXY + ", 0, 0, " + zoomXY + ", 0, 0)");

            // Header title
            if (scrollStep > 100) {
                var zoomTitleXY = ((scrollStep - 100) / 7) + 1;

                var blurTitle = ((scrollStep - 100) / 10);
                if (blurTitle < 40) $(".header .title-lev1").css({
                    "transform": "translateY(-" + zoomTitleXY + "px)",
                    "filter": "blur(" + blurTitle + "px)"
                });
            } else {
                $(".header .title-lev1").css({
                    "transform": "translateY(0px)",
                    "filter": "blur(0px)"
                });
            }

            // Header subtitle
            var zoomSubtitleXY = (scrollStep / 15) + 1;
            if (zoomSubtitleXY < 40) $(".header .sub-title-lev1").css("transform", "translateY(-" + zoomSubtitleXY + "px)");
        });
    }
}